import { Button, Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay, Text } from '@chakra-ui/react';
import React from 'react'

export default function ConfirmModal({ modalHeader, isOpen, onOpen, onClose, modalText }) {
    return (
        <Modal closeOnOverlayClick={false} isOpen={isOpen} onClose={onClose}>
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>{modalHeader}</ModalHeader>
                <ModalCloseButton />
                <ModalBody pb={6}>
                    <Text>{modalText}</Text>
                </ModalBody>

                <ModalFooter>
                    <Button colorScheme='blue' mr={3}>
                        OK
                    </Button>
                    <Button onClick={onClose}>
                        キャンセル
                    </Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    )
}
